import { render } from "./BSwitch.vue?vue&type=template&id=7d822de3&scoped=true"
import script from "./BSwitch.vue?vue&type=script&lang=js"
export * from "./BSwitch.vue?vue&type=script&lang=js"

import "./BSwitch.vue?vue&type=style&index=0&id=7d822de3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d822de3"]])

export default __exports__